import { useContext } from "react";
import { DataManContext } from "../defines";

export const useDataMan = () => {
  const context = useContext(DataManContext);
  if (context === undefined) {
    throw new Error("useDataMan must be used within a DataManProvider");
  }
  return context;
};
